import React, {useEffect, useState, useMemo} from 'react';
import Input from '../Input';
import {
  useGetAgencyQuery,
  useUpdateAgencyCorrectiveSettingsMutation,
} from '../../store/builder/inspections.api';
import CustomSelect from '../CustomSelect';
import {setLoader} from '../../store/builder/reducer';
import {toast} from 'react-toastify';
import {useDispatch, useSelector} from 'react-redux';
import {useErrorHandler} from '../../global/ErrorsHandler';
import {useTranslation} from '../../hooks/useTranslation';

const CorrectiveActions = () => {
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const userInfo = useSelector(state => state?.rootReducer?.loginSlice?.user);
  const {
    data: agencyData,
    error: agencyError,
    isLoading: agencyIsLoading,
    isSuccess: agencyIsSuccess,
    isError: agencyIsError,
  } = useGetAgencyQuery();
  const [
    updateAgencyCorrectiveSettings,
    {
      data: updateAgancyData,
      isError: updateAgancyIsError,
      isLoading: updateAgancyIsLoading,
      isSuccess: updateAgancyIsSuccess,
      error: updateAgancyError,
    },
  ] = useUpdateAgencyCorrectiveSettingsMutation();

  const [errorHandler, setErrorHandler] = useErrorHandler([updateAgancyError]);

  const [changeData, setChangeData] = useState({});
  const solidRating = useMemo(() => [
    {
      value: 1,
      label: t('correctiveActions.ratings.solid.clean'),
    },
    {
      value: 2,
      label: t('correctiveActions.ratings.solid.slight'),
    },
    {
      value: 3,
      label: t('correctiveActions.ratings.solid.particulate'),
    },
    {
      value: 4,
      label: t('correctiveActions.ratings.solid.dirty'),
    },
  ], [t]);
  const waterRating = useMemo(() => [
    {
      value: 'A',
      label: t('correctiveActions.ratings.water.bright'),
    },
    {
      value: 'B',
      label: t('correctiveActions.ratings.water.hazy'),
    },
    {
      value: 'C',
      label: t('correctiveActions.ratings.water.cloudy'),
    },
    {
      value: 'D',
      label: t('correctiveActions.ratings.water.wet'),
    },
    {
      value: 'E',
      label: t('correctiveActions.ratings.water.surfactants'),
    },
  ], [t]);

  useEffect(() => {
    if (agencyIsSuccess) {
      setChangeData({
        nozzle_fueling_pressure: userInfo?.agency?.nozzle_fueling_pressure,
        sump_solid_rating: userInfo?.agency?.sump_solid_rating,
        sump_water_rating: userInfo?.agency?.sump_water_rating,
        sump_trend_alert: userInfo?.agency?.sump_trend_alert,
        differential_pressure: userInfo?.agency?.differential_pressure,
        nozzle_fueling_pressure_decommission:
          userInfo?.agency?.nozzle_fueling_pressure_decommission,
        // differential_pressure_decommission: userInfo?.agency?.differential_pressure_decommission
      });
    }
  }, [agencyIsSuccess, userInfo]);

  useEffect(() => {
    if (updateAgancyIsLoading || agencyIsLoading) {
      dispatch(setLoader(true));
    } else {
      dispatch(setLoader(false));
    }
  }, [updateAgancyIsLoading, agencyIsLoading]);

  const handleInput = e => {
    setChangeData(old => ({...old, [e.target.name]: e.target.value}));
  };

  const updateFbo = () => {
    const formData = new FormData();
    formData.append(
      'sump_solid_rating',
      changeData?.sump_solid_rating !== null
        ? changeData?.sump_solid_rating
        : '',
    );
    formData.append(
      'sump_water_rating',
      changeData?.sump_water_rating !== null
        ? changeData?.sump_water_rating
        : '',
    );
    formData.append(
      'sump_trend_alert',
      changeData?.sump_trend_alert !== null ? changeData?.sump_trend_alert : '',
    );
    formData.append(
      'nozzle_fueling_pressure',
      changeData?.nozzle_fueling_pressure !== null
        ? changeData?.nozzle_fueling_pressure
        : '',
    );
    formData.append(
      'differential_pressure',
      changeData?.differential_pressure !== null
        ? changeData?.differential_pressure
        : '',
    );
    formData.append(
      'nozzle_fueling_pressure_decommission',
      changeData?.nozzle_fueling_pressure_decommission !== null
        ? changeData?.nozzle_fueling_pressure_decommission
        : '',
    );
    // formData.append('differential_pressure_decommission', changeData?.differential_pressure_decommission);

    updateAgencyCorrectiveSettings(formData)
      .then(res => {
        toast.success(res?.data?.message);
      })
      .catch(error => {
        toast.error(error.message);
      });
  };

  return (
    <div>
      <div className='profile__info profile'>
        <div className='profile__info column'>
          <p className='profile__title'>{t('correctiveActions.title')}</p>
          <p className='profile__subtitle'>
            {t('correctiveActions.subtitle')}
          </p>
          <div className='profile-corrective-actions'   style={{ pointerEvents: userInfo?.is_sso_auth ? 'none' : 'auto'}}>
            <Input
              disabled={userInfo?.agency?.has_corporate_settings}
              tooltip={true}
              tooltipText={t('correctiveActions.fields.nozzleFuelingPressureTooltip')}
              label={t('correctiveActions.fields.nozzleFuelingPressure')}
              maxwidth={395}
              placeholder={t('correctiveActions.fields.nozzleFuelingPressurePlaceholder')}
              name={'nozzle_fueling_pressure'}
              defaultValue={userInfo?.agency?.nozzle_fueling_pressure}
              onChange={handleInput}
            />
            <Input
              disabled={userInfo?.agency?.has_corporate_settings}
              tooltip={true}
              tooltipText={t('correctiveActions.fields.differentialPressureTooltip')}
              label={t('correctiveActions.fields.differentialPressure')}
              maxwidth={395}
              placeholder={t('correctiveActions.fields.differentialPressurePlaceholder')}
              name={'differential_pressure'}
              defaultValue={userInfo?.agency?.differential_pressure}
              onChange={handleInput}
            />
            <CustomSelect
              disabled={userInfo?.agency?.has_corporate_settings}
              tooltip={true}
              tooltipText={t('correctiveActions.fields.sumpSolidRatingTooltip')}
              label={t('correctiveActions.fields.sumpSolidRating')}
              tooltipWidth={250}
              placeholder={t('correctiveActions.fields.sumpSolidRatingPlaceholder')}
              name={'sump_solid_rating'}
              defaultValue={
                userInfo?.agency?.sump_solid_rating
                  ? solidRating.filter(
                      el => el.value == userInfo?.agency?.sump_solid_rating,
                    )[0]
                  : ''
              }
              onChange={handleInput}
              options={solidRating}
              maxwidth={'100%'}
            />
            <CustomSelect
              disabled={userInfo?.agency?.has_corporate_settings}
              tooltip={true}
              tooltipText={t('correctiveActions.fields.sumpWaterRatingTooltip')}
              label={t('correctiveActions.fields.sumpWaterRating')}
              tooltipWidth={250}
              maxwidth={'100%'}
              placeholder={t('correctiveActions.fields.sumpWaterRatingPlaceholder')}
              name={'sump_water_rating'}
              defaultValue={
                userInfo?.agency?.sump_water_rating
                  ? waterRating?.filter(
                      el => el.value === userInfo?.agency?.sump_water_rating,
                    )[0]
                  : ''
              }
              onChange={handleInput}
              options={waterRating}
            />
            <div style={{marginTop: '15px'}}>
              <Input
                disabled={userInfo?.agency?.has_corporate_settings}
                tooltip={true}
                tooltipText={t('correctiveActions.fields.nozzleFuelingPressureDecommissionTooltip')}
                label={t('correctiveActions.fields.nozzleFuelingPressureDecommission')}
                maxwidth={395}
                placeholder={t('correctiveActions.fields.nozzleFuelingPressureDecommissionPlaceholder')}
                name={'nozzle_fueling_pressure_decommission'}
                defaultValue={
                  userInfo?.agency?.nozzle_fueling_pressure_decommission
                }
                onChange={handleInput}
              />
            </div>
            {/*<div style={{marginTop: '30px'}}>*/}
            {/*<Input*/}
            {/*  tooltip={true}*/}
            {/*  tooltipText={"Differential Pressure Decommission"}*/}
            {/*  label={"Differential Pressure Decommission"}*/}
            {/*  maxwidth={395}*/}
            {/*  placeholder={"Differential Pressure Decommission"}*/}
            {/*  name={"differential_pressure_decommission"}*/}
            {/*  defaultValue={userInfo?.agency?.differential_pressure_decommission}*/}
            {/*  onChange={handleInput}*/}
            {/*/>*/}
            {/*</div>*/}
            <div style={{marginTop: '15px'}}>
              <Input
                disabled={userInfo?.agency?.has_corporate_settings}
                tooltip={true}
                tooltipText={t('correctiveActions.fields.sumpTrendAlertTooltip')}
                label={t('correctiveActions.fields.sumpTrendAlert')}
                maxwidth={395}
                placeholder={t('correctiveActions.fields.sumpTrendAlertPlaceholder')}
                name={'sump_trend_alert'}
                defaultValue={userInfo?.agency?.sump_trend_alert}
                onChange={handleInput}
              />
            </div>
          </div>
        </div>
        {!userInfo?.is_sso_auth && <button
            style={{marginTop: '15px', width: '130px'}}
            className='profile__methods-btn'
            onClick={updateFbo}
        >
          {t('actions.save')}
        </button>}
      </div>
    </div>
  );
};

export default CorrectiveActions;
